"use client";

import { useState } from "react";
import { DynamicCaseStudies } from "./dynamic_case_studies";
import { PerspectivePieceFormModal, BusinessInfluencerFormModal } from "@/components/modals/FormModal";

interface CaseStudyItem {
	title: string;
	text: string;
	imageUrl: string;
	link: string;
	openModal?: string;
}

interface CaseStudiesWithModalProps {
	items: CaseStudyItem[];
	start_with_a_pilot?: boolean;
	showViewAll?: boolean;
	showSeeMore?: boolean;
}

export function CaseStudiesWithModal({ items, start_with_a_pilot, showViewAll, showSeeMore }: CaseStudiesWithModalProps) {
	const [isPerspectiveModalOpen, setIsPerspectiveModalOpen] = useState(false);
	const [isBusinessInfluencerModalOpen, setIsBusinessInfluencerModalOpen] = useState(false);

	return (
		<>
			<DynamicCaseStudies 
				items={items}
				start_with_a_pilot={start_with_a_pilot}
				showViewAll={showViewAll}
				showSeeMore={showSeeMore}
				onItemClick={(item) => {
					if (item.openModal === "perspective-piece") {
						setIsPerspectiveModalOpen(true);
					} else if (item.openModal === "business-influencer") {
						setIsBusinessInfluencerModalOpen(true);
					}
				}}
			/>
			<PerspectivePieceFormModal
				open={isPerspectiveModalOpen}
				onOpenChange={setIsPerspectiveModalOpen}
			/>
			<BusinessInfluencerFormModal
				open={isBusinessInfluencerModalOpen}
				onOpenChange={setIsBusinessInfluencerModalOpen}
			/>
		</>
	);
}
